import type { PromotionPricingRule } from '@/app/services/pos.service'

export interface DiscountSnapshot {
  promotion_id?: number | null
  name?: string | null
  type?: 'percentage' | 'fixed_amount' | 'buy_x_pay_y' | null
  value?: string | number | null
  fixed_application?: 'per_unit' | 'per_line' | null
  buy_quantity?: number | null
  pay_quantity?: number | null
  channel?: 'pos' | 'ecommerce' | 'both' | null
  starts_at?: string | null
  ends_at?: string | null
}

type DisplayableRule = PromotionPricingRule | DiscountSnapshot | null | undefined

export function pricingRuleName(rule: DisplayableRule): string | null {
  if (!rule) return null
  return (rule as PromotionPricingRule).promotion_name
    || (rule as DiscountSnapshot).name
    || null
}

export function pricingRuleLabel(rule: DisplayableRule): string | null {
  if (!rule) return null
  const type = (rule as PromotionPricingRule).promotion_type
    || (rule as DiscountSnapshot).type
  if (type === 'percentage') return `${Number(rule.value || 0).toLocaleString('es-MX')}% de descuento`
  if (type === 'fixed_amount') {
    return `$${Number(rule.value || 0).toFixed(2)} de ahorro final ${rule.fixed_application === 'per_line' ? 'por línea' : 'por unidad'}`
  }
  if (type === 'buy_x_pay_y') return `Compra ${rule.buy_quantity}, paga ${rule.pay_quantity}`
  return null
}

export function isPromotionPricing(rule: PromotionPricingRule | null | undefined): boolean {
  return rule?.source === 'promotion' && Boolean(rule.promotion_id)
}
